import { render, staticRenderFns } from "./CountDownTime.vue?vue&type=template&id=35ef8903&scoped=true&"
import script from "./CountDownTime.vue?vue&type=script&lang=ts&"
export * from "./CountDownTime.vue?vue&type=script&lang=ts&"
import style0 from "./CountDownTime.vue?vue&type=style&index=0&id=35ef8903&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35ef8903",
  null
  
)

export default component.exports